import { render, staticRenderFns } from "./bulananPurata.vue?vue&type=template&id=42e19806&scoped=true"
import script from "./bulananPurata.vue?vue&type=script&lang=js"
export * from "./bulananPurata.vue?vue&type=script&lang=js"
import style0 from "./bulananPurata.vue?vue&type=style&index=0&id=42e19806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e19806",
  null
  
)

export default component.exports